import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { 
  getListBuyerMatch,
  getListCustomer,
  getCountBuyerMatch,
  getListListingCustomer,
  getDetailCustomer,
  getCountListingBuyerMatch,
  getDetailListingBuyerMatch
} from "./api"

export const useGetListBuyerMatch = ({ params, enabled = true }) => {
  return useQuery({
    queryKey: ['get-list-buyer-match', params],
    queryFn: () => getListBuyerMatch(params),
    enabled: enabled
  })
}

export const useGetListCustomer = ({ params, enabled = true }) => {
  return useQuery({
    queryKey: ['get-list-customer', params],
    queryFn: () => getListCustomer(params),
    enabled: enabled
  })
}

export const useGetCountBuyerMatch = ({ enabled = true }) => {
  return useQuery({
    queryKey: ['get-count-buyer-match'],
    queryFn: () => getCountBuyerMatch(),
    enabled: enabled
  })
}

export const useGetListListingCustomer = ({ id, params, enabled = true }) => {
  return useQuery({
    queryKey: ['get-list-listing-customer', id, params],
    queryFn: () => getListListingCustomer(id, params),
    enabled: enabled
  })
}

export const useGetListListingCustomerInfinite = ({ id, params, enabled = true }) => {
  return useInfiniteQuery({
    queryKey: ['get-list-listing-customer', id, params],
    queryFn: ({ pageParam = 1 }) => getListListingCustomer(id, {...params, page: pageParam}),
    getNextPageParam: (lastPage) => {
      return !!lastPage?.data?.data?.listings?.length ? +lastPage.headers["x-page"] + 1 : undefined
    },
    enabled: enabled
  })
}

export const useGetDetailCustomer = ({ id, enabled = true }) => {
  return useQuery({
    queryKey: ['get-detail-customer', id],
    queryFn: () => getDetailCustomer(id),
    enabled: enabled
  })
}

export const useGetCountListingBuyerMatch = ({ id, enabled = true }) => {
  return useQuery({
    queryKey: ['get-count-listing-buyer-match', id],
    queryFn: () => getCountListingBuyerMatch(id),
    enabled: enabled
  })
}

export const useGetDetailListingBuyerMatch = ({ id, enabled = true }) => {
  return useQuery({
    queryKey: ['get-detail-listing-buyer-match', id],
    queryFn: () => getDetailListingBuyerMatch(id),
    enabled: enabled
  })
}
